export default "__VITE_ASSET__jU0JA_7q__"